//-------------------------------------------------------------------------------------------------- Imports
import { Row, Col, Card, Typography, Button } from "antd";
import { StyleSheet } from "../../StyleSheet";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import { getTrackingOt } from "../../methods/Methods";
import { ResponseTrackingOt } from "../../types/common";
import Loading from "../../components/Loading";
import InfoCardComponent from "../../components/InfoCardComponent";
import ContactAgent from "./ContactAgent";
const { Text } = Typography;

//-------------------------------------------------------------------------------------------------- View
const OrderService = () => {
    const generalData = useSelector(getGeneralData);
    const [idCliente, setIdCliente] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [isActive, setIsActive] = useState<boolean>(false);
    const [dataOrder, setDataOrder] = useState<ResponseTrackingOt>();
    const [message, setMessage] = useState<string>("");
    const [contactAgent, setContactAgent] = useState<boolean>(false);
    useEffect(() => {
        if (generalData.selectedContract !== null) {
            const newIdCliente = generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor;
            setIdCliente(newIdCliente);
        }
    }, [generalData.selectedContract]);

    useEffect(() => {
        if (idCliente) {
            setLoading(true)
            getTrackingOt(idCliente)
                .then((response) => {
                    if (response.data.data[0] && response.data.data[0].status === 1) {
                        setIsActive(true);
                    } else if (response.data.data[0] && response.data.data[0].status === 2) {
                        setIsActive(false);
                    } else {
                        setIsActive(false);
                        setMessage(response.data.data[0].message);
                    }
                    setDataOrder(response.data.data[0])
                    setLoading(false);
                })
                .catch(() => {
                    setLoading(false);
                })
        }
    }, [idCliente])

    const handleNavigation = () => {
        setContactAgent(true);
    };

    return (
        <SubDefaultLayout
            title={contactAgent ? "Contacta a un Agente" : "Órdenes de Servicio"}
            needReturn={true}
            navigateTo="/technical-support">
            {
                contactAgent ? (
                    <ContactAgent />
                ) : (
                    <Row style={styles.rowRoot}>
                        <Col xs={20} xl={18} style={{ paddingLeft: 10 }}>
                            <Card bodyStyle={{ justifyContent: 'center' }} style={{ ...styles.cardRoot }} >
                                {
                                    loading ?
                                        (<Loading />)
                                        : (
                                            <>
                                                <Row style={styles.rowPrincipal}>
                                                    {isActive ? (
                                                        <>
                                                            <Col style={{ width: '20%', flexDirection: 'column' }}>
                                                                <Row>
                                                                    <Text style={styles.textColor}>
                                                                        Folio
                                                                    </Text>
                                                                </Row>
                                                                <Row style={styles.rowContent}>
                                                                    <Text style={{ fontWeight: 600, color: 'black', fontSize: 15 }}>
                                                                        {dataOrder?.folio}
                                                                    </Text>
                                                                </Row>
                                                            </Col>
                                                            <Col style={{ width: '40%', flexDirection: 'column' }}>
                                                                <Row>
                                                                    <Text style={styles.textColor}>
                                                                        Órden de Servicio
                                                                    </Text>
                                                                </Row>
                                                                <Row style={styles.rowContent}>
                                                                    <Text style={{ color: 'black', fontSize: 15 }}>
                                                                        {dataOrder?.description}
                                                                    </Text>
                                                                </Row>
                                                            </Col>
                                                            <Col style={{ width: '40%', flexDirection: 'column' }}>
                                                                <Row>
                                                                    <Text style={styles.textColor}>
                                                                        Estado
                                                                    </Text>
                                                                </Row>
                                                                <Row style={styles.rowContent}>
                                                                    <Text style={{ color: 'black', fontSize: 15 }}>
                                                                        {dataOrder?.message}
                                                                    </Text>
                                                                </Row>
                                                            </Col>
                                                        </>
                                                    ) : (
                                                        <Col style={{ width: '60%', flexDirection: 'column' }}>
                                                            {message !== null && message !== "" && !isActive ? (
                                                                <Text style={{ ...styles.text, color: '#e20514' }}>
                                                                    {message}
                                                                </Text>
                                                            ) : (
                                                                <Text style={styles.text}>
                                                                    {dataOrder?.message}
                                                                </Text>
                                                            )}

                                                        </Col>
                                                    )}
                                                </Row>
                                            </>
                                        )
                                }
                            </Card>
                        </Col>
                        <Col xs={16} xl={14} style={{ paddingLeft: 10 }}>
                            <InfoCardComponent
                                title="¡Estimado usuario!"
                                description="Si tiene dudas con su servicio, favor de comunicarse al área de servicio al cliente."
                            />
                        </Col>
                        <Col xs={16} xl={14} style={{ paddingLeft: 10, display: 'flex', marginTop: 15, justifyContent: 'center' }}>
                            <Button style={styles.buttonFinal}
                                type="primary"
                                onClick={() => handleNavigation()}

                            >
                                Contacta a un agente
                            </Button>
                        </Col>
                    </Row>
                )
            }
        </SubDefaultLayout >
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    cardRoot: {
        backgroundColor: 'white',
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 20
    },
    rowRoot: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 5
    },
    rowPrincipal: {
        width: '100%',
        padding: 10,
        flexDirection: 'row',
        display: 'flex'
    },
    rowContent: {
        height: '70%',
        alignContent: 'center',
        marginTop: 5
    },
    textColor: {
        color: "#115ac2",
        fontSize: 18,
        fontWeight: 600
    },
    text: {
        color: "#115ac2",
        fontSize: 16,
        fontWeight: 500
    },
    buttonFinal: {
        backgroundColor: '#0055c2',
        borderRadius: 15,
        color: 'white',
        boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.10)",
        marginBottom: 10
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default OrderService;
